import { useFormContext } from "react-hook-form";
import { PhoneFieldProps } from "./Phone.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { Label } from "@shadcn/components/ui/label";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";
import { PhoneInput } from "@shadcn/components/ui/phone-input";
import type { CountryCode } from "libphonenumber-js";

export const Phone = ({ label, name, required, validation, config, disabled }: PhoneFieldProps) => {
  const { control } = useFormContext();
  const description = getFieldHelperText(config.helperText, required);
  const validationConfig = getValidationConfig(validation);

  return (
    <FormField
      control={control}
      defaultValue={config.defaultValue}
      rules={{
        ...validationConfig,
        required: {
          value: required,
          message: "This is a required field",
        },
        validate: {
          phoneNumber: (value) => {
            if (!value) return true; // Let required rule handle empty values
            // Basic phone validation - you can enhance this if needed
            return value.length >= 10 || "Please enter a valid phone number";
          },
        },
      }}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-2">
          {label && <Label htmlFor={name}>{label}</Label>}
          <FormMessage />
          <FormControl>
            <PhoneInput
              {...field}
              id={name}
              defaultCountry={(config.defaultCountry ?? "GB") as CountryCode}
              international={config.international ?? false}
              countrySelectProps={{ unicodeFlags: true }}
              placeholder={config.placeholder}
              disabled={disabled}
              aria-label={label}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};
